module.exports = __webpack_public_path__ + "media/images/icons/outlined/fund-projection-screen-cbbcc87962dfb37e5373f7ed66ded65b.svg";